import log from 'salvo-lite/log'
import 'slick-carousel'
import jQuery from 'jquery'

class Slick {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: true,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null
        }, JSON.parse(this._elem.dataset.slick))

        this._initialized = false

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }

        if (!this.options.dontInit) {
            this.init()
        }
        log.debug(this._name, 'Constructed', this)
    }

    onInit () {
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        jQuery(this._elem).on('init', (e, slick) => {
            this._initialized = true
            this._elem.classList.add('show-slider')
            this._elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        jQuery(this._elem).not('.slick-initialized').slick(this.options)

        jQuery(this._elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.pause()
            }
        })

        jQuery(this._elem).on('afterChange', (e, slick, curSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })

        if (this._elem.parentNode.parentNode.classList.contains('tablet-only')) {
            var _elem = this._elem
            var checkExist = setInterval(function () {
                if (_elem.classList.contains('show-slider')) {
                    var elements = _elem.querySelectorAll('.slick-slide:not(.slick-cloned)')
                    elements.forEach(function (element) {
                        if (element.innerHTML.includes(window.location.pathname)) {
                            jQuery(_elem).slick('slickGoTo', parseInt(element.getAttribute('data-slick-index')))
                        }
                    })
                    clearInterval(checkExist)
                }
            }, 100)
        }
    }
}

export default Slick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slick.js